export default __webpack_public_path__ + "static/media/login-bg.cb1a685c.jpg";